export default __webpack_public_path__ + "static/media/330_business04-en-mobile.62460a70.png";